import React from "react";
import { Link } from "react-router-dom";

const UseCasesPage = () => {
  return (
    <section className="subpage-section">
      <div className="container">
        <h1 className="subpage-title">Use Cases</h1>
        <p className="subpage-body">
          FeraBio supports two core customer groups: broad nanopore teams that
          need easier cloud workflows, and advanced XNA users who need
          specialized model support.
        </p>
        <div className="subpage-feature-grid">
          <div className="subpage-feature-card">
            <h3>General Nanopore Users</h3>
            <p>
              Teams running routine sequencing who want faster onboarding and
              lower infrastructure burden.
            </p>
            <Link to="/product/basecalling" className="read-more-link">
              Read more
            </Link>
          </div>
          <div className="subpage-feature-card">
            <h3>XNA and Modified-base Teams</h3>
            <p>
              Smaller but high-need teams that benefit from exclusive models and
              differentiated workflows.
            </p>
            <Link
              to="/product/basecalling#xna-models"
              className="read-more-link"
            >
              Read more
            </Link>
          </div>
          <div className="subpage-feature-card">
            <h3>Platform-led Labs</h3>
            <p>
              Labs aiming to centralize basecalling, clustering, and discovery
              pipelines in one cloud environment.
            </p>
            <Link to="/waitlist" className="read-more-link">
              Request access
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default UseCasesPage;
